export default __webpack_public_path__ + "static/media/you-first-logo.03720be3.png";